module.exports = __webpack_public_path__ + "img/footer_google.1bb81ed7.png";